const { ACCOUNT_STATUSES } = require('constants/accountConstants');

// for countries Columbia(id = 1), Mexico(id = 2), Argentina(id = 66)
const isEnviagoAvailable = (user) =>
    user.status === ACCOUNT_STATUSES?.accepted && (user?.countryId === 1 || user?.countryId === 2 || user?.countryId === 66);

export default isEnviagoAvailable;
